import CheckAltIcon from '../../assets/images/Icons/Check/CheckAlt';
import InfoIcon from '../../assets/images/Icons/Info/Info';
import WarningIcon from '../../assets/images/Icons/Warning';
import { COLORS } from '../../config/designSystem/Colors';
import { Caption2Reg } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native';


interface BannerProps {
    type: 'success' | 'info' | 'warning',
    label: string
}

export const Banner = ({ type, label }: BannerProps) => {

  const borderColor = COLORS.state[type].primary;
  const backgroundColor = COLORS.state[type]['inverse-primary'];



  const renderIcon = () => {
    const SIZE= 24;
    switch (type) {
    case 'success':
      return <CheckAltIcon width={SIZE} height={SIZE}/>;
    case 'info':
      return <InfoIcon width={SIZE} height={SIZE} />;
    case 'warning':
      return <WarningIcon width={SIZE} height={SIZE} />;
    }
  };

  return (
    <View style={{
      width: '100%',
      backgroundColor,
      borderColor,
      borderWidth: 1,
      borderRadius: SPACING['sp-12'],
      padding: SPACING['sp-12'],
      flexDirection:'row',
      columnGap: SPACING['sp-12'],
      alignItems: 'center'
    }}>
      {renderIcon()}
      <Caption2Reg color={borderColor}>{label}</Caption2Reg>
    </View>
  );
};

